/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M.8977 10.0284a.75.75 0 0 0-.827.6642v.0004c-.327 2.9934.489 6.0181 2.277 8.441l.0015.0019a.75.75 0 0 0 1.2067-.8909c-1.5654-2.1202-2.2803-4.7697-1.994-7.3896a.75.75 0 0 0-.6642-.827Zm12.3076-8.4602c-2.6383-.3029-5.3114.4109-7.4476 1.9885a.75.75 0 0 1-.891-1.2066C7.3081.547 10.3607-.2682 13.3762.078a.75.75 0 0 1 .6596.8306.75.75 0 0 1-.8306.6596Zm9.232 11.6219c.0185-.1636.0332-.3274.0439-.4911.1619-2.4629-.5523-4.9244-2.0188-6.9204a.75.75 0 0 1 1.2088-.8881l.0005.0006.0009.0013c1.7869 2.4331 2.5953 5.4685 2.255 8.4682a.75.75 0 1 1-1.4903-.1705Zm-3.3595 8.5071a11.957 11.957 0 0 1-.9299.6137c-2.2325 1.3284-4.8558 1.9061-7.4549 1.6222l-.0014-.0001a.75.75 0 0 1 .163-1.4911l.0013.0001a10.34 10.34 0 0 0 .4863.0416c2.4384.1515 4.873-.5552 6.8536-1.9997a.75.75 0 0 1 1.0479.164.75.75 0 0 1-.164 1.0479l-.0019.0014Z"
    clipRule="evenodd"
  />,
  'DeployConsole'
);
